import {GetWomenChannelParams} from 'domain/usecases';
import {
	makeGetWomenChannelUrl,
	// makeMockedGetWomenChannelUrl as makeGetWomenChannelUrl,
} from 'main/factories/usecases/private/external-links/remote-help';

const getWomenChannelUrl = async ({signal}: GetWomenChannelParams) =>
	makeGetWomenChannelUrl().get({signal});

export {getWomenChannelUrl};
